import {
    TOPIC_FINGERPRINT_REQUEST,
    TOPIC_FINGERPRINT_ERROR_RESPONSE,
    TOPIC_FINGERPRINT_RESPONSE,
    UNAUTHENTICATED,
} from "../../actions/action-types"

export const convertFPToFlow = (fp) => {
    if (!fp) {
        return null
    }
    const flow = fp.map(({ concept, normalized_count }) => ({
        key: concept,
        count: normalized_count.toFixed(3),
    }))
    flow.sort((flow1, flow2) => flow2.count - flow1.count)
    return flow
}

export default (state = {}, action) => {
    const { type, id, data, error, receivedAt } = action
    switch (type) {
        case TOPIC_FINGERPRINT_REQUEST:
            return {
                ...state,
                [id]: {
                    ...(state[id] || {}),
                    isFetching: true,
                    error: null,
                },
            }
        case TOPIC_FINGERPRINT_RESPONSE:
        case TOPIC_FINGERPRINT_ERROR_RESPONSE:
            let flow = []
            if (data) {
                flow = convertFPToFlow(data.fp)
            }
            return id || data
                ? {
                      ...state,
                      [id || data.requested]: {
                          ...(data || {}),
                          flow,
                          isFetching: false,
                          lastUpdatedAt: receivedAt,
                          error: error || null,
                      },
                  }
                : state
        case UNAUTHENTICATED:
            return {}
        default:
            return state
    }
}
